module.exports = __webpack_public_path__ + "static/img/087_TO8_1742.8b8686b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/087_TO8_1742.jpg
// module id = fFcS
// module chunks = 0